import { render, staticRenderFns } from "./MultipleAnswerInput.vue?vue&type=template&id=510759da&"
import script from "./MultipleAnswerInput.vue?vue&type=script&lang=js&"
export * from "./MultipleAnswerInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports